<template>
  <div
    v-if="showCTA"
    class="insights-cta-banner-workforce-wrapper"
  >
    <InsightsCTABanner
      type="workforce"
      :is-loading="isLoading"
      :hide-action-button="false"
      @hide="hideCTA"
      @showDialog="toggleDialog"
      @submit="submitCTA"
      @close="closeCTA"
    />
    <InsightsCTABannerDialog
      v-if="showDialog"
      :show="showDialog"
      type="workforce"
      @close="toggleDialog"
    />
  </div>
</template>

<script>
import InsightsCTABanner from '~/components/insights/InsightsCTABanner.vue';

export default {
  name: 'DashboardWorkforceBanner',
  components: {
    InsightsCTABanner,
    InsightsCTABannerDialog: () => import('~/components/insights/InsightsCTABannerDialog.vue'),
  },
  props: {
    initialState: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    localStorageHiddenKey: 'insightsWorkforceCTAHidden',
    type: 'workforce',
    showCTA: false,
    isLoading: false,
    showDialog: false,
    dismiss: false,
    url: '#',
  }),
  mounted() {
    const {
      // show_insights_banner: (isOwner || IsManager) && flag is enabled
      show_insights_banner: showInsightsBanner,
      insights_url: url,
    } = this.initialState;

    this.url = url;
    this.showCTA = showInsightsBanner && !localStorage.getItem(this.localStorageHiddenKey);
  },
  methods: {
    toggleDialog(show = false) {
      this.showDialog = show;
      this.dismissCTA();
    },
    submitCTA() {
      this.dismissCTA();
      this.isLoading = true;
      window.location.href = this.url;
    },
    closeCTA() {
      this.dismissCTA();
      this.showCTA = false;
    },
    hideCTA(dismiss) {
      this.dismiss = dismiss;
    },
    dismissCTA() {
      if (this.dismiss) {
        localStorage.setItem(this.localStorageHiddenKey, true);
      }
    }
  },
};
</script>
